// extracted by mini-css-extract-plugin
export default {"totalHandraisersValue":"totalHandraisers_totalHandraisersValue__SbhoF"};